'use client';

import { useCallback, useContext, useEffect, useState } from 'react';
import {
  NavigationItemStoryblok,
  NavigationRootStoryblok,
} from 'storyblok-types';
import { renderLink } from 'atoms/StoryBlokLink';
import { usePathname } from 'modules/next/hooks';
import { SiteConfigContext } from './Context';

export const useSiteConfig = () => {
  return useContext(SiteConfigContext);
};

export const useActiveNavigationItem = (
  items: NavigationRootStoryblok | undefined,
) => {
  const pathname = usePathname();
  const [activeItem, setActiveItem] = useState<
    NavigationItemStoryblok | undefined
  >();

  const flattenMenuItem = useCallback(
    (menuItem: NavigationItemStoryblok): NavigationItemStoryblok[] => {
      const result = [menuItem];
      if (menuItem.children && menuItem.children.length > 0) {
        result.push(...menuItem.children.flatMap(flattenMenuItem));
      }
      if (menuItem.flyoutColumns && menuItem.flyoutColumns.length > 0) {
        result.push(
          ...menuItem.flyoutColumns.flatMap(
            (column): NavigationItemStoryblok[] => {
              if (column.items && column.items.length > 0) {
                return column.items.flatMap(flattenMenuItem);
              }
              return [];
            },
          ),
        );
      }
      return result;
    },
    [],
  );

  useEffect(() => {
    if (items?.children && pathname) {
      const activeFoundItem = items.children?.find((topLevelItem) => {
        const flattenItems = flattenMenuItem(topLevelItem);
        const foundItem = flattenItems?.find((item) => {
          return pathname === renderLink(item.url);
        });
        return !!foundItem;
      });
      setActiveItem(activeFoundItem);
    }
  }, [pathname, items, flattenMenuItem]);

  return activeItem;
};
